import { render, staticRenderFns } from "./MoleculeFeedSectionContentCardEditionDesign2.vue?vue&type=template&id=3cb5a007&"
import script from "./MoleculeFeedSectionContentCardEditionDesign2.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionContentCardEditionDesign2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports